import { useCallback, useRef } from "react";
import { usePopupManagerContext } from "./PopupManagerContext";

export const usePopupPortalManager = ({ popupType }) => {
  const { curOpenRef, setCurOpen } = usePopupManagerContext();
  const locked = useRef();

  const checkIsLocked = useCallback(() => {
    return Boolean(curOpenRef.current);
  }, [curOpenRef]);
  const checkIsUnlocked = useCallback(() => {
    return !checkIsLocked();
  }, [checkIsLocked]);

  const lockPopup = useCallback(() => {
    if (!curOpenRef.current) {
      setCurOpen(popupType);
      locked.current = true;
    }
  }, [curOpenRef, popupType, setCurOpen]);
  const unlockPopup = useCallback(() => {
    if (curOpenRef.current === popupType) {
      setCurOpen(null);
      locked.current = false;
    }
  }, [curOpenRef, popupType, setCurOpen]);

  return { checkIsLocked, checkIsUnlocked, lockPopup, unlockPopup };
};
